import * as AgentrepairOrderDetailApi from '../../api/agentRepairApi'

const state={
    agentrepairOrderDetailInput:{
    },
    agentrepairOrderDetailOutput:{
       
    },
    hasError:false
    
}

const getters={

}

const actions ={
    async getAgentrepairOrderDetail({commit},agentrepairOrderDetailInput){
        const response =await AgentrepairOrderDetailApi.getAgentrepairOrderDetail(agentrepairOrderDetailInput);
        commit('setAgentrepairOrderDetail',response)
        return response
    } 
}

const mutations ={
    setAgentrepairOrderDetail(state,data){
        state.hasError=!data.Status
        if(data.Status){
            state.agentrepairOrderDetailOutput=data.Data;
        }
    },
    clear(state,data){
        state.hasError=false
        state.noticeListOutput={
            Rows:[],
            HasNext:true,
            PageNo:0,
            PageSize:15
        }
    }
}

export default{
     namespaced:true,
     getters,
     state,
     actions,
     mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/agentrepairOrderDetail.js